var conf = {
    name: 'marketmaker',
    url_keyname: 'marketmaker',
    api_keyname: 'marketmaker',
    template: 'MarketMakerTemplate',
    mobile: 1,
}

export default conf



// WEBPACK FOOTER //
// ./src/companies/marketmaker/configs/marketmaker.conf.js